<div class="dark text-justify scroll-box">
  <div class="info-header">
    <h4 class="info-title">{{ 'Responsible Gaming' | translate }}</h4>
  </div>
  <hr>

  <ng-container *ngIf="mainContent && mainContent.length > 0 && !isSkeletonMainContent; else skeletonMainContent">
    <div class="m-b-25 main-content vip-faq">
      <p [innerHTML]="sanitize(mainContent[0]?.description)" class="m-b-0"></p>
    </div>
  </ng-container>

  <ng-template #skeletonMainContent>
    <ng-container *ngIf="isSkeletonMainContent">
      <ng-container *ngFor="let item of [].constructor(4)">
        <p class="skeleton skeleton-text mb-1"></p>
      </ng-container>
      <p class="skeleton skeleton-text mb-3 w-75"></p>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="responsibleGaming && !isSkeletonMainContent; else skeletonResponsibleGaming">
    <mat-accordion class="vip-faq">
      <ng-container *ngFor="let row of responsibleGaming; trackBy: trackByRowId">
        <ng-container *ngIf="row.content_type == 2 && row.status == 1">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" (afterExpand)="scroll(row.id)" hideToggle class="m-b-10">
            <mat-expansion-panel-header>
              <mat-panel-title [id]="row.id">
                {{ row.title }}
                <i class="icon-chevron-down dropdown-arrow-img"></i>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p [innerHTML]="sanitize(row.description)"></p>
          </mat-expansion-panel>
        </ng-container>
      </ng-container>
    </mat-accordion>
  </ng-container>

  <ng-template #skeletonResponsibleGaming>
    <ng-container *ngIf="isSkeletonMainContent">
      <div *ngFor="let item of [].constructor(5) | slice:0:1">
        <mat-accordion class="faq-section">
          <ng-container *ngFor="let item of [].constructor(5)">
            <mat-expansion-panel class="m-b-15 border-0 skeleton-faq-mat-header">
              <mat-expansion-panel-header class="skeleton"></mat-expansion-panel-header>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
    </ng-container>
  </ng-template>
</div>
